export const getFirstPart = (str) => {
  if (typeof str !== "string") {
    throw new Error("Input must be a string");
  }

  const parts = str.split("-");

  if (parts.length === 1) {
    return str;
  }

  return parts[0].trim();
}
